import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#004030",
      light: "#335c4f",
      dark: "#002920",
    },
    secondary: {
      main: "#41b883",
      light: "#6ccb9f",
      dark: "#2d805c",
    },
    background: {
      default: "#f8f9fa",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 600,
      letterSpacing: "-0.5px",
    },
    h5: {
      fontWeight: 500,
      letterSpacing: "0.1px",
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 8,
          padding: "10px 24px",
        },
        sizeLarge: {
          height: 48,
        },
      },
    },
  },
});
